<template>
  <SnowDataPoint
    label="Area Open"
    :left-align="leftAlign"
    :responsive-row="responsiveRow"
    :value-class-names="areaPercentOpenClassNames"
  >
    <div v-if="isClosed">
      <span class="md:tw-hidden">
        CLD
      </span>
      <span class="tw-hidden md:tw-inline">
        {{ closedText }}
      </span>
    </div>
    <div v-else>
      {{ areaPercentOpen }}
    </div>
  </SnowDataPoint>
</template>

<script>
import {
  dataNotAvailable,
  getAreaPercentOpen,
  getClosedText,
  isClosed,
} from '@@/utils/CommonUtils';

export default {
  name: 'SnowAreaOpenDataPoint',

  props: {
    leftAlign: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    responsiveRow: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    areaPercentOpen() {
      return getAreaPercentOpen(this.location.resort_report);
    },

    areaPercentOpenClassNames() {
      if (this.isClosed) {
        return 'text-saturated-red-color';
      }

      if (this.areaPercentOpen === dataNotAvailable) {
        return 'text-light-color';
      }

      return null;
    },

    closedText() {
      return getClosedText(this.location?.resort_report) || dataNotAvailable;
    },

    isClosed() {
      return isClosed(this.location.resort_report);
    },
  },
};
</script>
